
import { toast as sonnerToast } from "sonner";

export type ToastProps = {
  title?: string;
  description?: string;
  variant?: "default" | "destructive";
  duration?: number;
  action?: React.ReactNode;
};

export function toast({
  title,
  description,
  variant = "default",
  duration = 3000,
  action,
}: ToastProps) {
  // Create options object with the properties that sonner accepts
  const options: {
    duration?: number;
    className?: string;
    action?: React.ReactNode;
    description?: string;
  } = {
    duration,
    className: variant === "destructive" ? "bg-destructive text-destructive-foreground" : "",
    action
  };

  // If there's a description, add it to the options
  if (description) {
    options.description = description;
  }

  // Use the sonner toast with the title and options
  return sonnerToast(title || "", options);
}

// Create a custom useToast hook that wraps the sonner toast functionality
export function useToast() {
  return {
    toast,
    // Provide the dismiss functionality from sonner
    dismiss: sonnerToast.dismiss,
    // This is needed for the Toaster component
    toasts: [] // Empty array as we're using sonner's internal state management
  };
}
